'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoIosBell = function IoIosBell(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm29.8 17.7c0 8.9 2.2 9.8 5.2 12.3h-30c3-2.5 5.2-3.4 5.2-12.3 0-7.7 4.1-10.2 7.9-10.8v-0.2c0-0.9 0.9-1.7 1.9-1.7s1.9 0.8 1.9 1.7v0.2c3.8 0.5 7.9 3.1 7.9 10.8z m-9.8 17.3c-2.1 0-3.8-1.6-4.1-3.4h8.2c-0.3 1.8-2 3.4-4.1 3.4z' })
        )
    );
};

exports.default = IoIosBell;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/ios-bell.js
// module id = 2317
// module chunks = 0